/*==================================================
REPLICA RACK • FOOTER V3
==================================================*/

document.addEventListener("DOMContentLoaded", initFooter);
document.addEventListener("shopify:section:load", initFooter);

function initFooter() {

  /* Footer always visible */
  const footer = document.querySelector(".rr-footer");
  if (footer) {
    footer.classList.add("is-visible");
  }

  /* Mobile Accordion */
  if (window.innerWidth <= 768) {

    const menus = document.querySelectorAll(".rr-footer__menu");

    menus.forEach(menu => {

      const button = menu.querySelector(".rr-footer__heading");

      if (!button) return;

      button.onclick = function () {

        menus.forEach(item => {

          if (item !== menu) {
            item.classList.remove("active");
          }

        });

        menu.classList.toggle("active");

      };

    });

  }

}